import React,{ useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { Header, Icon } from 'semantic-ui-react'

function PhotoWidgetDropzone({setFiles}) {

	const onDrop = useCallback(acceptedFiles => {
		acceptedFiles.map(file=>console.log(file))
		setFiles(acceptedFiles.map(file => Object.assign(
			file,
			{
				preview:URL.createObjectURL(file)
			}
		)))
	},[setFiles])

	const {getRootProps,getInputProps,isDragActive} = useDropzone({onDrop})
	const dropzoneStyles = {
		border :'3px dashed #eee',
		borderRadius:'5%',
		paddingTop:'30px',
		textAlign:'center'
	}
	const dropzoneActive = {
		border:'dashed 3px green'
	}


	return (
		<div {...getRootProps()} style={isDragActive ? {...dropzoneStyles, ...dropzoneActive}:{...dropzoneStyles}}>
			<input {...getInputProps() } />
			<Icon name='upload' size='huge' />
			<Header content='drop image here' />
			
		</div>
	)
}

export default PhotoWidgetDropzone
